class Seccion{
    constructor(id, codigo, descripcion){
        this.id = id;
        this.codigo = codigo;
        this.descripcion = descripcion;
    }
}
export default Seccion;